// Material UI
import { Box, Button } from "@mui/material";

// Components
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { useState } from "react";

// Constants
import { TYPE_TRANSFER_REQUEST } from "../../constants";

// Types
import { TTransferType } from "../../types";
import { InventoryFilterItem } from "../../contexts/InventoryFilterContext";

import { resolveDisableOptions } from "../../helpers";

type TStartTransferRequestProps = {
	permission: boolean;
	transferType: TTransferType;
	setTransferType: (value: TTransferType) => void;
	filterItems: InventoryFilterItem[];
	isCurrentPayPeriod: boolean;
};

export const StartTransferRequest = (props: Readonly<TStartTransferRequestProps>) => {
	const { permission = false, transferType, setTransferType, filterItems, isCurrentPayPeriod } = props;
	const [selectedTransferType, setSelectedTransferType] = useState<TTransferType>(transferType);

	const disableOptions = resolveDisableOptions(filterItems);

	if (transferType) {
		return null;
	}

	return (
		<Box className="flex pt-[32px]">
			<Box className="!w-[130px] mr-[24px]">
				<SmartSelector
					disabled={!permission || !isCurrentPayPeriod}
					showBy="label"
					selectBy="label"
					options={TYPE_TRANSFER_REQUEST.filter(Boolean).map((transfer) => ({ label: transfer }))}
					selected={selectedTransferType}
					disabledOptions={disableOptions}
					inputProps={{
						placeholder: "Transfer Type",
					}}
					onChangeAction={(value) => {
						setSelectedTransferType((value as { label: TTransferType })?.label);
					}}
				/>
			</Box>
			<Button
				variant="contained"
				disabled={!selectedTransferType || !isCurrentPayPeriod}
				onClick={() => {
					if (selectedTransferType) {
						setTransferType(selectedTransferType);
						setSelectedTransferType("" as TTransferType);
					}
				}}
			>
				Start Transfer
			</Button>
		</Box>
	);
};
